import React from 'react'
import Locale from '../data/localization'
import { substitute } from '../utils/String'

const getContent = (node, floor) => {
    let text = ''
    if (node === 'ge2') {
        text = substitute(Locale.map.garage.directElevator, { floor })
    }

    if (node === 'ge1') {
        text = substitute(Locale.map.garage.elevator, { floor })
    }

    if (node === '230b') {
        text = substitute(Locale.map.garage.escalator, { floor })
    }

    return {
        __html: text
    }
}

const GarageStart = ({ path, nextFloor }) => (
    <div className="Garage">
        <div className="Garage-content">
            <div className="Garage-title">{Locale.map.garage.title}</div>
            <div className="Garage-text" dangerouslySetInnerHTML={getContent(path[1], nextFloor)} />
        </div>
    </div>
)

export default GarageStart


// WEBPACK FOOTER //
// ./components/GarageStart.js